import styles from "./taskcard.module.css";
import { ChevronDown, Copy, Edit, MoreVertical, Trash2 } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import dayjs from "dayjs";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    maxWidth: 400,
    fontSize: 13,
    textAlign: "left",
  },
}));

const TaskCard = ({
  item,
  setDeleteTaskModalOpen,
  setArchiveTaskModalOpen,
  setIsArchive,
  setEditTaskModalOpen,
  setDetailsTaskModalOpen,
  setSelectedId,
  setCopyTaskModalOpen,
}) => {
  return (
    <div
      className={`${styles.ProspectCard}`}
      onClick={(e) => {
        setDetailsTaskModalOpen(true);
        setSelectedId(item?.id);
      }}
    >
      <div className={`${styles.ProspectCardUnder}`}>
        <div className={`${styles.ProspectCardHeadSection}`}>
          <Dropdown
            className={`${styles.ActionLeaseBUSec}`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Dropdown.Toggle
              className={`${styles.ActionsLeaseBU} ActionsBU`}
              id="dropdown-basic"
            >
              <MoreVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
              <Dropdown.Item
                className={`${styles.EditActionsBUListItem}`}
                onClick={(e) => {
                  setEditTaskModalOpen(true);
                  setSelectedId(item?.id);
                }}
              >
                <Edit /> Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={`${styles.EditActionsBUListItem}`}
                onClick={(e) => {
                  setCopyTaskModalOpen(true);
                  setSelectedId(item?.id);
                }}
              >
                <Copy /> Copy
              </Dropdown.Item>
              <Dropdown.Item
                className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                onClick={(e) => {
                  setDeleteTaskModalOpen(true);
                  setSelectedId(item?.id);
                }}
              >
                <Trash2 /> Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className={`${styles.ProsIMGSec}`}>
            <img src="/static/img/tasklist.svg" alt="" />
          </div>
          <div className={`${styles.HeadConSec}`}>
            <p className={`${styles.ProsUserName}`}>
              <span className={`${styles.UserName}`}>{item?.title}</span>
            </p>
            <p className={`${styles.ProsUserName} ${styles.Small}`}>
              {item?.technician_name !== '' ? item?.technician_name + ' Assigned' : '-'}
            </p>
          </div>
        </div>
        <div className={`${styles.ProspectCardBodySec}`}>
          <ul>
            <li>
              <p className={`${styles.Title}`}>Frequency:</p>
              <p className={`${styles.Content}`}>
                {item?.days?.length > 0 ? item?.days[0] : '-'}
                {item?.days?.length > 1 && (
                  <BootstrapTooltip
                    title={
                      <div className={`${styles.IncomeLineTooltip}`}>
                        {item?.days?.map((it, ind) => {
                          return ind > 0 ? (
                            <p>
                              #{ind}. {it}
                            </p>
                          ) : null;
                        })}
                      </div>
                    }
                  >
                    <span className={`${styles.MorePropertyBU}`}>
                      +{item?.days?.length - 1}
                    </span>
                  </BootstrapTooltip>
                )}
              </p>
            </li>
            <li>
              <p className={`${styles.Title}`}>Property:</p>
              <p className={`${styles.Content} ${styles.Hover}`}>
                {item?.property_name !== '' ? item?.property_name : '-'}
              </p>
            </li>
          </ul>
        </div>
        <div className={`${styles.ProspectCardFootSec}`}>
          <p className={`${styles.LeaseConDate}`}>
            {dayjs(item?.created_at).fromNow()}
          </p>
          <div className={`${styles.MainReqConDropBU}`}>
            <Dropdown
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Dropdown.Toggle
                id="dropdown-basic"
                className={
                  item?.is_archived === 1
                    ? `${styles.ReferStatusBU} ${styles.StatusBuRed}`
                    : `${styles.ReferStatusBU} ${styles.StatusBuGreen}`
                }
              >
                {item?.is_archived === 1 ? "Disable" : "Enable"}{" "}
                <ChevronDown className={`${styles.DownArrowStatus}`} />
              </Dropdown.Toggle>

              <Dropdown.Menu className="DropDownMenuBoxCus">
                {item?.is_archived === 1 && (
                  <Dropdown.Item
                    className="DropDListWIcon"
                    onClick={(e) => {
                      setArchiveTaskModalOpen(true);
                      setSelectedId(item?.id);
                      setIsArchive(false);
                    }}
                  >
                    Enable
                  </Dropdown.Item>
                )}
                {item?.is_archived === 0 && (
                  <Dropdown.Item
                    className="DropDListWIcon"
                    onClick={(e) => {
                      setArchiveTaskModalOpen(true);
                      setSelectedId(item?.id);
                      setIsArchive(true);
                    }}
                  >
                    Disable
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskCard;
